import React from 'react'
import { LoginPage } from '@pilot-hub/ui'
import { userApi } from '@pilot-hub/api-client'
import { useAuth } from '@pilot-hub/auth'
import { useNavigate } from 'react-router-dom'

interface LoginUser {
  id: string
  benutzername: string
  vorname?: string
  nachname?: string
}

export function LoginPagePilot() {
  const { login } = useAuth()
  const navigate = useNavigate()

  // Nach dem Login immer zuerst auf "Flug erfassen" (Start/Ende erfassen).
  const defaultPath = '/flug-erfassen'
  
  return (
    <LoginPage
      module="pilot"
      title="Piloten-Modul"
      loginEndpoint="/auth/login"
      redirectPath={defaultPath}
      getLoginUsers={async (): Promise<LoginUser[]> => {
        const response = await userApi.getLoginPilots()
        return response.data as LoginUser[]
      }}
      onLogin={login}
    />
  )
}